/* tslint:disable */
/* eslint-disable */
/**
 * MG-DX Personal Health Record API
 * API for PHR
 *
 * The version of the OpenAPI document: 0.2.0
 * Contact: developers@mg-dx.co.jp
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { tzDate } from "@mgdx-libs/dayjs";
import { exists, mapValues } from "../runtime";
import { PhrMeasurement, PhrMeasurementFromJSON, PhrMeasurementFromJSONTyped, PhrMeasurementToJSON } from "./";

export const PhrHbA1csTypename = "PhrHbA1cs" as const;

/**
 *
 * @export
 * @interface PhrHbA1cs
 */
export interface PhrHbA1cs {
  /**
   *
   * @type {PhrMeasurement}
   * @memberof PhrHbA1cs
   */
  enzyme?: PhrMeasurement;
  /**
   *
   * @type {PhrMeasurement}
   * @memberof PhrHbA1cs
   */
  hplc?: PhrMeasurement;
  /**
   *
   * @type {PhrMeasurement}
   * @memberof PhrHbA1cs
   */
  immunologic?: PhrMeasurement;
  /**
   *
   * @type {PhrMeasurement}
   * @memberof PhrHbA1cs
   */
  other?: PhrMeasurement;
  /**
   * Resource type name
   * @type {string}
   * @memberof PhrHbA1cs
   */
  readonly __typename?: string;
}

export function PhrHbA1csFromJSON(json: any): PhrHbA1cs {
  return PhrHbA1csFromJSONTyped(json, false);
}

export function PhrHbA1csFromJSONTyped(json: any, ignoreDiscriminator: boolean): PhrHbA1cs {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    __typename: PhrHbA1csTypename,

    enzyme: !exists(json, "enzyme") ? undefined : PhrMeasurementFromJSON(json["enzyme"]),
    hplc: !exists(json, "hplc") ? undefined : PhrMeasurementFromJSON(json["hplc"]),
    immunologic: !exists(json, "immunologic") ? undefined : PhrMeasurementFromJSON(json["immunologic"]),
    other: !exists(json, "other") ? undefined : PhrMeasurementFromJSON(json["other"]),
  };
}

export function PhrHbA1csToJSON(object?: PhrHbA1cs | null): any {
  if (object === undefined) {
    return undefined;
  }
  if (object === null) {
    return null;
  }
  const { __typename, ...value } = object;
  return {
    enzyme: PhrMeasurementToJSON(value.enzyme),
    hplc: PhrMeasurementToJSON(value.hplc),
    immunologic: PhrMeasurementToJSON(value.immunologic),
    other: PhrMeasurementToJSON(value.other),
  };
}
